import Id from './Id';
import Product from './Product';
import Storage from './Storage';
import CreatorUser from './CreatorUser';
import Type from './Type';
import Count from './Count';
import Created from './Created';
import Updated from './Updated';

export const labels = {
  Id: 'Id',
  Product: 'Termék',
  Storage: 'Raktár',
  CreatorUser: 'Rögzítette',
  Type: 'Típus',
  Count: 'Mennyiség',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Product',
  fixed: true,
}, {
  value: 'Storage',
}, {
  value: 'CreatorUser',
}, {
  value: 'Type',
}, {
  value: 'Count'
},{
  value: 'Updated',
}, {
  value: 'Created',
},
];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Product',
  fixed: true,
}, {
  value: 'Storage',
}, {
  value: 'CreatorUser',
}, {
  value: 'Type',
}, {
  value: 'Count'
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'descending'
};

export default {
  Product,
  Storage,
  CreatorUser,
  Type,
  Count,
  Updated,
  Created,
  Id,
};
